/* eslint-disable */
export default {
  tollFree: 'Gratuit',
  rcvPmiMeetingTitle: 'Visioconférence de {extensionName}',
} as const;

// @key: @#@"tollFree"@#@ @source: @#@"Toll-Free"@#@
// @key: @#@"rcvPmiMeetingTitle"@#@ @source: @#@"{extensionName}'s video meeting"@#@
